import * as moment from "moment-timezone";
import { Router } from '@angular/router';

declare const $;

export class Utilities {
    static isValidUrl(url: string) {
        // Regular expression to validate URL format
        const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/;
        return urlPattern.test(url);
    }
    static isValidHostname(host: string) {
        // Regular expression to validate hostname format
        const hostnamePattern = /^(?!:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
        return hostnamePattern.test(host);
    }

    static isValidEmail(email: string) {
        // Regular expression to validate email format
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailPattern.test(email);
    }

    static onlinecheck(router: Router) { // Function to check if user token is already valid
        let currentUser = JSON.parse(localStorage.getItem('currentUser')); // Get current user
        if (currentUser) { // Check if user exists
            let expires: any = moment(currentUser.expires); // Get token expires date
            let now: any = moment();
            if (expires > now) setTimeout(function() { Utilities.onlinecheck(router); }, 10000); // If token is valid check again after 10 secs
            else router.navigate(['/logout']); // If token is expired, logout
        }
    }

    static toUpperCaseFirst(str) {
        return str.replace(/\w\S*/g, function(txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
    }

    static replaceAll(target, search, replacement) {
        return target.split(search).join(replacement);;
    }

    static diposeTooltips() {
        (<any>$('[data-toggle="m-tooltip"]')).tooltip('dispose');
        (<any>$('.tooltip')).remove();
    }

    static initTooltips() {
        setTimeout(() => {
            // init bootstrap tooltips
            (<any>$('[data-toggle="m-tooltip"]')).each(function() {
                var skin = (<any>$(this)).data('skin') ? 'm-tooltip--skin-' + (<any>$(this)).data('skin') : '';
                var width = (<any>$(this)).data('width') == 'auto' ? 'm-tooltop--auto-width' : '';
                var triggerValue = (<any>$(this)).data('trigger') ? (<any>$(this)).data('trigger') : 'hover';

                (<any>$(this)).tooltip({
                    trigger: triggerValue,
                    template: `<div class="m-tooltip ${skin} ${width} tooltip" role="tooltip">
                                    <div class="arrow"></div>
                                    <div class="tooltip-inner"></div>
                                </div>`
                });
            });
        }, 100);
    }

    static checkField(field: any) {
        if (typeof field === "boolean") {
            return field !== undefined && field !== null;
        } else if (field instanceof Array) {
            return field !== undefined && field !== null && field.length > 0;
        } else if (field instanceof Object) {
            return field !== undefined && field !== null && Object.keys(field).length > 0;
        } else {
            return field !== undefined && field !== null && field !== '';
        }
    }

    static enumToArray<T extends Record<string, string | number>>(enumObj: any): T[keyof T][] {
        return Object.values(enumObj).map(x => x as T[keyof T]) as T[keyof T][];
    }

    static generateRandomString(length: number = 6): string {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';

        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * chars.length);
            result += chars.charAt(randomIndex);
        }

        return result;
    }

    /**
     * Store tenant name in local storage
     * @param tenant 
     */
    static storeTenantName(tenant: string) {
        localStorage.setItem('tenant_name', tenant);
    }

    /**
     * Get tenant name from local storage
     * @returns 
     */
    static getTenantName() {
        return localStorage.getItem('tenant_name') || "";
    }

    /**
     * Delete tenant name from local sotage
     */
    static deleteTenantName() {
        localStorage.removeItem('tenant_name');
    }

    /**
     * Store tenant service name in local storage
     * @param tenant 
     */
    static storeTenantServiceName(tenant: string) {
        localStorage.setItem('tenant_service_name', tenant);
    }

    /**
     * Get tenant service name from local storage
     * @returns 
     */
    static getTenantServiceName() {
        return localStorage.getItem('tenant_service_name') || "";
    }

    /**
     * Delete tenant service name from local sotage
     */
    static deleteTenantServiceName() {
        localStorage.removeItem('tenant_service_name');
    }

    // From 12/24/01 the Vendors are recovered by API
    // static Vendors() {
    //     return [
    //         { id: "pfsense", itemName: "pfSense" },
    //         { id: "ruckus", itemName: "Ruckus" },
    //         { id: "teltonika", itemName: "Teltonika" },
    //         { id: "aruba", itemName: "Aruba" },
    //         { id: "mikrotik", itemName: "Mikrotik" },
    //         { id: "meraki", itemName: "Meraki" },
    //         { id: "tplink", itemName: "TP-Link" },
    //         { id: "coovachilli", itemName: "CoovaChilli" },
    //         { id: "extreme", itemName: "Extreme" },
    //         { id: "engenius", itemName: "EnGenius" },
    //         { id: "fortigate", itemName: "Fortigate" },
    //         { id: "huawei", itemName: "Huawei" },
    //         { id: "cambium", itemName: "Cambium" },
    //         { id: "test", itemName: "Test" },
    //     ];
    // }
}
